import api from '../../utils/api';

export type AwarenessSectionType = 'what' | 'why' | 'prevention' | 'faq' | 'summary';

export interface AwarenessEvent {
  event_id: string;
  event_type: 'health' | 'seasonal';
  event_subtype: 'day' | 'week' | 'month';

  title: string;
  theme?: string | null;
  short_description?: string | null;

  featured_image?: string | null;

  start_date?: string | null;
  end_date?: string | null;

  region?: string | null;
  priority?: number | null;
  active?: boolean;

  tags?: string | null;

  createdAt?: string;
  updatedAt?: string;
}

export interface AwarenessContentRow {
  id: number;
  event_id: string;
  section: AwarenessSectionType;
  content: string;
  display_order: number;
  status: 'published' | 'draft';
  createdAt?: string;
  updatedAt?: string;
}

// ---------- Events ----------
export const getAwarenessEvents = async (): Promise<AwarenessEvent[]> => {
  const response = await api.get('/awareness/admin/calendar');
  return response.data?.data || [];
};

export const getAwarenessEventById = async (eventId: string): Promise<AwarenessEvent> => {
  const response = await api.get(`/awareness/admin/calendar/${eventId}`);
  return response.data?.data || response.data;
};

export const createAwarenessEvent = async (payload: FormData) => {
  return api.post('/awareness/admin/calendar', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateAwarenessEvent = async (eventId: string, payload: FormData) => {
  return api.put(`/awareness/admin/calendar/${eventId}`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteAwarenessEvent = async (eventId: string) => {
  return api.delete(`/awareness/admin/calendar/${eventId}`);
};

// ---------- Sections ----------
export const getAwarenessSections = async (
  eventId: string
): Promise<AwarenessContentRow[]> => {
  const response = await api.get(`/awareness/admin/content/${eventId}`);
  return response.data?.data || [];
};

export const createAwarenessSection = async (payload: {
  event_id: string;
  event_type: 'health' | 'seasonal';
  section: AwarenessSectionType;
  content: string;
  display_order: number;
  status: 'published' | 'draft';
}) => {
  return api.post('/awareness/admin/content', payload);
};

export const updateAwarenessSection = async (
  id: number,
  payload: Partial<{
    section: AwarenessSectionType;
    content: string;
    display_order: number;
    status: 'published' | 'draft';
  }>
) => {
  return api.put(`/awareness/admin/content/${id}`, payload);
};

export const deleteAwarenessSection = async (id: number) => {
  return api.delete(`/awareness/admin/content/${id}`);
};